import React from "react";

import { Box, Typography } from "@mui/material";

export type IOptionFontStyle = "normal" | "italic";

export interface IBaseLabel {
  id?: string;
  children: string | JSX.Element;
  fontSize?: string;
  marginBottom?: string;
  marginTop?: string;
  marginRight?: string;
  marginLeft?: string;
  font?: "Inter";
  fontWeight?: string;
  fontStyle?: IOptionFontStyle;
  color?: string;
  colorHover?: string;
  bold?: boolean;
  lineHeight?: string;
  m?: number | "none";
  disabled?: boolean;
  background?: string;
  width?: string;
}

export const BaseLabel: React.FC<IBaseLabel> = ({
  id,
  children,
  fontSize = "12px",
  marginBottom,
  marginTop,
  marginRight,
  marginLeft,
  color,
  colorHover,
  fontWeight,
  fontStyle,
  m,
  disabled,
  width,
}) => {
  return (
    <Typography component="div" id={id} fontSize={fontSize}>
      <Box
        sx={{
          width: width,
          fontWeight: fontWeight,
          m: m || 1,
          color: color,
          marginBottom: marginBottom || "none",
          marginTop: marginTop || "none",
          marginRight: marginRight || "none",
          marginLeft: marginLeft || "none",
          fontStyle: fontStyle ?? "normal",
          font: "Inter",
          fontFamily: "Inter",
          opacity: disabled ? 0.6 : 1,
          "&:hover": {
            color: colorHover ?? color,
          },
        }}
      >
        {children}
      </Box>
    </Typography>
  );
};

export default BaseLabel;
